import React, { useEffect } from "react";
import Select from "react-select";

type Props = {
	value: string,
	isDisabled?: boolean,
	updateConfig: Function
}

const PageType = (props: Props) => {
	const metrics = [
		{label: "All", value: "all"},
		{label: "Articles", value: "article"},
		{label: "Landing pages", value: "landing"},
	];

	useEffect(() => {
		if (props.isDisabled === true && props.value !== "") {
			props.updateConfig(['page_type'], ["all"]);
		}
	}, [props.isDisabled]);
	
	return (
		<div className="form-group">
			<label htmlFor="metricType">Page type:</label>
			<Select
				id="metricType"
				className="basic-single"
				classNamePrefix="so-select-metric-type"
				value={props.value ? metrics.find(item => item.value === props.value) : {label: "All", value: "all"}}
				options={metrics}
				isDisabled={props.isDisabled}
				onChange={e => props.updateConfig(['page_type'], [e!.value])}
				menuPortalTarget={document.body}
				styles={{menuPortal: base => ({...base, zIndex: 9999})}}
			/>
		</div>
	);
};

export default PageType;
